// extracted by extract-css-chunks-webpack-plugin
module.exports = {"marketingSlot":"kEsrf","topWrapper":"ziXvB"};